import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
var CasePracticeCooperationComponent = (function () {
    function CasePracticeCooperationComponent(route, router, apiService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
    }
    CasePracticeCooperationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
            if (_this.type) {
                localStorage.setItem('isPC', _this.type);
            }
        });
        this.route.params.subscribe(function (params) {
            _this.learningPathId = params['learningPathId'];
            _this.practiceMetaId = params['practiceMetaId'];
            _this.exerciseId = params['exerciseId'];
            _this.isPC = !!localStorage.getItem('isPC');
            if (_this.exerciseId > 0 || localStorage.getItem('isIframe')) {
                _this.page = 'video';
            }
            else {
                _this.page = 'list';
            }
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/' + _this.learningPathId + '/' + _this.practiceMetaId + '/createAndGet'
            }).subscribe(function (result) {
                _this.practiceList = result.exercise;
                _this.practiceId = result.id;
                _this.apiService.ajax({
                    'type': 'post',
                    'url': 'sr/practice/correctLearningPath/' + _this.practiceId,
                    'data': { 'practiceId': _this.practiceId }
                }).subscribe(function (result) {
                    console.log(result);
                });
            });
            console.log(_this.page);
        });
        setTimeout(function () {
            if (_this.type) {
                $('#userIdContainer').val(JSON.parse(localStorage.getItem('userInfo'))['userId']);
            }
        }, 500);
    };
    CasePracticeCooperationComponent.prototype.setPracticeIndex = function (i) {
        this.practiceIndex = i;
        this.exerciseId = this.practiceList[this.practiceIndex].id;
    };
    CasePracticeCooperationComponent.prototype.goToNextStep = function (i) {
        console.log(i);
        if (i == 1) {
            this.page = 'video';
        }
        else if (i == 2) {
            this.page = 'begin';
        }
        else if (i == 3) {
            this.page = 'question';
        }
    };
    return CasePracticeCooperationComponent;
}());
export { CasePracticeCooperationComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation/case-practice-cooperation.component.ts.pre-build-optimizer.js